import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastSixDigit'
})
export class LastSixDigitPipe implements PipeTransform {

  transform(value: string): string {
    // Assuming value is a string representing the quoteId
    if (value && value.length > 6) {
      return value.slice(-6).toUpperCase(); // Return last 6 characters
    } else {
      if (value) {
        return value.toUpperCase(); // Return the original value if it's not longer than 6 characters
      } else {
        return "";
      }
    }
  }
}
